import { render, staticRenderFns } from "./LinkPanel.vue?vue&type=template&id=5b07786c&scoped=true"
import script from "./LinkPanel.vue?vue&type=script&lang=js"
export * from "./LinkPanel.vue?vue&type=script&lang=js"
import style0 from "./LinkPanel.vue?vue&type=style&index=0&id=5b07786c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b07786c",
  null
  
)

export default component.exports